export const teacherCourses = {
	type: 'array',
	items: {
		type: 'object',
		required: ['id'],
		properties: {
			id: {
				type: 'integer'
			}
		}
	}
};